import { useIntl } from "react-intl";

import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { Social } from "@/components/signup/account-creation/components/social/social";
import { useCfind6099JiraGoogleOnlySocialProviders } from "@/components/signup/hooks/use-cfind-6099-jira-google-only-social-providers";
import { useDeferSiteNamingContinueUrl } from "@/components/signup/hooks/use-defer-site-naming-continue-url";
import { JiraOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";

import { GetStartedText } from "../../../components/get-started-heading";
import { Headings } from "../../../components/headings";
import { InputSubmitButton } from "../../../components/submit-input";

export const LoggedOutJiraPremium = () => {
    const socialSignupProviders = useCfind6099JiraGoogleOnlySocialProviders();
    const getContinueUrl = useDeferSiteNamingContinueUrl();

    const intl = useIntl();

    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.premium",
        defaultMessage:
            "30-day free trial for unlimited users on the Premium plan — no credit card needed"
    });

    return (
        <JiraOverlayTemplate size="sm">
            <Headings
                main={<GetStartedText productName="Jira" />}
                sub={heading2}
            />
            <AccountCreation
                Input={<InputSubmitButton />}
                Social={<Social providers={socialSignupProviders} />}
                Submit={null}
                getContinueUrl={getContinueUrl}
            />
        </JiraOverlayTemplate>
    );
};
